import * as React from 'react';
import { SVGProps } from 'react';

export const Storage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M17 29H3V3H17V29ZM4 28H16V4H4V28Z" fill="#071114" />
    <path d="M29 29H16V23H29V29ZM17 28H28V24H17V28Z" fill="#071114" />
    <path d="M29 24H16V19H29V24ZM17 23H28V20H17V23Z" fill="#071114" />
    <path d="M22 23H23V29H22V23Z" fill="#071114" />
    <path d="M21.5 21H23.5V22H21.5V21Z" fill="#071114" />
    <path d="M16 4.5H29V5.5H16V4.5Z" fill="#071114" />
    <path
      d="M26.375 14H20.625C20.2294 13.9988 19.8477 13.8533 19.5517 13.5908C19.2557 13.3282 19.0657 12.9667 19.0172 12.5741C18.9687 12.1814 19.0652 11.7846 19.2885 11.4579C19.5118 11.1313 19.8465 10.8974 20.23 10.8L23.5 10L26.77 10.815C27.1535 10.9124 27.4882 11.1463 27.7115 11.4729C27.9348 11.7996 28.0313 12.1964 27.9828 12.5891C27.9343 12.9817 27.7443 13.3432 27.4483 13.6058C27.1523 13.8683 26.7706 14.0138 26.375 14.015V14ZM23.5 11L20.47 11.755C20.3049 11.7756 20.1547 11.8609 20.0525 11.9921C19.9503 12.1234 19.9044 12.2899 19.925 12.455C19.9456 12.6201 20.0309 12.7703 20.1621 12.8725C20.2934 12.9747 20.4599 13.0206 20.625 13H26.375C26.5269 12.9996 26.6735 12.9438 26.7872 12.8432C26.901 12.7425 26.9743 12.6039 26.9933 12.4531C27.0123 12.3024 26.9757 12.1499 26.8904 12.0242C26.8052 11.8985 26.6771 11.8081 26.53 11.77L23.5 11Z"
      fill="#071114"
    />
    <path
      d="M24 11H23V9.295L23.795 8.5C23.9261 8.36657 23.9997 8.18707 24 8C24 7.86739 23.9473 7.74021 23.8536 7.64645C23.7598 7.55268 23.6326 7.5 23.5 7.5C23.3674 7.5 23.2402 7.55268 23.1464 7.64645C23.0527 7.74021 23 7.86739 23 8V8.5H22V8C22 7.60218 22.158 7.22064 22.4393 6.93934C22.7206 6.65804 23.1022 6.5 23.5 6.5C23.8978 6.5 24.2794 6.65804 24.5607 6.93934C24.842 7.22064 25 7.60218 25 8C25.0001 8.22388 24.956 8.44558 24.8702 8.65237C24.7844 8.85916 24.6586 9.04696 24.5 9.205L24 9.705V11Z"
      fill="#071114"
    />
    <path d="M23 4.5H24V7.5H23V4.5Z" fill="#071114" />
    <path d="M14 14.5H15V18H14V14.5Z" fill="#071114" />
    <path
      d="M17 29H3V3H17V29ZM4 28H16V4H4V28Z"
      stroke="#071114"
      strokeWidth="0.3"
    />
    <path
      d="M29 29H16V23H29V29ZM17 28H28V24H17V28Z"
      stroke="#071114"
      strokeWidth="0.3"
    />
    <path
      d="M29 24H16V19H29V24ZM17 23H28V20H17V23Z"
      stroke="#071114"
      strokeWidth="0.3"
    />
    <path d="M22 23H23V29H22V23Z" stroke="#071114" strokeWidth="0.3" />
    <path d="M21.5 21H23.5V22H21.5V21Z" stroke="#071114" strokeWidth="0.3" />
    <path d="M16 4.5H29V5.5H16V4.5Z" stroke="#071114" strokeWidth="0.3" />
    <path
      d="M26.375 14H20.625C20.2294 13.9988 19.8477 13.8533 19.5517 13.5908C19.2557 13.3282 19.0657 12.9667 19.0172 12.5741C18.9687 12.1814 19.0652 11.7846 19.2885 11.4579C19.5118 11.1313 19.8465 10.8974 20.23 10.8L23.5 10L26.77 10.815C27.1535 10.9124 27.4882 11.1463 27.7115 11.4729C27.9348 11.7996 28.0313 12.1964 27.9828 12.5891C27.9343 12.9817 27.7443 13.3432 27.4483 13.6058C27.1523 13.8683 26.7706 14.0138 26.375 14.015V14ZM23.5 11L20.47 11.755C20.3049 11.7756 20.1547 11.8609 20.0525 11.9921C19.9503 12.1234 19.9044 12.2899 19.925 12.455C19.9456 12.6201 20.0309 12.7703 20.1621 12.8725C20.2934 12.9747 20.4599 13.0206 20.625 13H26.375C26.5269 12.9996 26.6735 12.9438 26.7872 12.8432C26.901 12.7425 26.9743 12.6039 26.9933 12.4531C27.0123 12.3024 26.9757 12.1499 26.8904 12.0242C26.8052 11.8985 26.6771 11.8081 26.53 11.77L23.5 11Z"
      stroke="#071114"
      strokeWidth="0.3"
    />
    <path
      d="M24 11H23V9.295L23.795 8.5C23.9261 8.36657 23.9997 8.18707 24 8C24 7.86739 23.9473 7.74021 23.8536 7.64645C23.7598 7.55268 23.6326 7.5 23.5 7.5C23.3674 7.5 23.2402 7.55268 23.1464 7.64645C23.0527 7.74021 23 7.86739 23 8V8.5H22V8C22 7.60218 22.158 7.22064 22.4393 6.93934C22.7206 6.65804 23.1022 6.5 23.5 6.5C23.8978 6.5 24.2794 6.65804 24.5607 6.93934C24.842 7.22064 25 7.60218 25 8C25.0001 8.22388 24.956 8.44558 24.8702 8.65237C24.7844 8.85916 24.6586 9.04696 24.5 9.205L24 9.705V11Z"
      stroke="#071114"
      strokeWidth="0.3"
    />
    <path d="M23 4.5H24V7.5H23V4.5Z" stroke="#071114" strokeWidth="0.3" />
    <path d="M14 14.5H15V18H14V14.5Z" stroke="#071114" strokeWidth="0.3" />
  </svg>
);
export default Storage;
